module.exports = __webpack_public_path__ + "img/bg-img.4f0d5d7e.png";